<template>
  <div id="contenedor-listado-mobiles">
    <v-card
      v-for="(adjudicacionDirecta, index) in listadoAdjudicacionesDirectas"
      :key="index"
      class="mb-2">
      <v-card-title class="justify-space-between">
        <div class="d-inline-block text-truncate">
          <v-btn text small color="primary" class="px-0" @click="abrirFicha(adjudicacionDirecta)">
            {{ adjudicacionDirecta.numeroContrato }}
          </v-btn>
        </div>
        <div class="d-inline-block">
          <opciones :adjudicacionDirecta="adjudicacionDirecta"> </opciones>
        </div>
      </v-card-title>
      <v-card-text>
        {{ adjudicacionDirecta.meta }}
      </v-card-text>
    </v-card>
  </div>
</template>

<script>

import Opciones from './Opciones.vue';

export default {
  name: 'ListadoMobiles',
  props: {
    listadoAdjudicacionesDirectas: {
      type: Array,
      required: true,
    },
  },
  components: {
    Opciones,
  },
  data() {
    return {};
  },
  methods: {
    abrirFicha(adjudicacionDirecta) {
      this.$router.push({
        name: 'adjudicacion',
        params: {
          idAdjudicacion: adjudicacionDirecta.id,
        },
      });
    },
  },
};
</script>

<style lang="scss">
</style>
